/** The Deep's elements (docs/spec/02 §7.3): expanding walls, keys and doors. Slime is in objects.ts. */

import { E } from '../elements';
import { isSpace, put, store } from '../grid';
import type { CaveState } from '../types';

/** Grows one cell left and one cell right into space, every scan. */
export function expandingWall(s: CaveState, x: number, y: number): void {
  if (isSpace(s, x - 1, y)) {
    store(s, x - 1, y, E.EXPANDING_WALL);
    s.events.push({ type: 'expand', x: x - 1, y });
  }
  if (isSpace(s, x + 1, y)) {
    store(s, x + 1, y, E.EXPANDING_WALL);
    s.events.push({ type: 'expand', x: x + 1, y });
  }
}

/** A key of `color` (0-2) was taken: every door of that colour starts opening. */
export function openDoors(s: CaveState, color: number): void {
  s.keys[color] = true;
  const door = E.DOOR + color;
  let any = false;
  for (let i = 0; i < s.cells.length; i++) {
    if (s.cells[i] === door) {
      s.cells[i] = E.DOOR_OPENING;
      s.stamp[i] = s.scan;
      any = true;
    }
  }
  if (any) s.events.push({ type: 'doorOpen', color });
}

export function doorOpening(s: CaveState, x: number, y: number): void {
  put(s, x, y, E.SPACE);
}
